import { render, staticRenderFns } from "./Buyfromcart.vue?vue&type=template&id=32fe423f&scoped=true&"
import script from "./Buyfromcart.vue?vue&type=script&lang=js&"
export * from "./Buyfromcart.vue?vue&type=script&lang=js&"
import style0 from "./Buyfromcart.vue?vue&type=style&index=0&id=32fe423f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fe423f",
  null
  
)

export default component.exports